<template>
    <b-form-group 
        :invalid-feedback="invalid_feedback"
        :label-for="field"
        :state='state'
        >
        <template #label v-if="_type != 'boolean'">
                    {{_label}} <span class="req_mark" v-if="_required == true">*</span>
        </template>

        <b-input 
            :id="field"
            v-model = 'parent.instance[field]'
            :state='state'
            :readonly="_readonly"
            :required = "_required"
            :type = '_type_normalized'
            :size="size"
            v-if="['email', 'password','string','integer','url'].includes(_type)"
        />
        
        <b-form-checkbox 
            :id="field"
            v-else-if="_type == 'boolean'"
            v-model="parent.instance[field]" 
            :disabled="_readonly"
            :state="state">
                <label :for="field">{{ _label }}</label>
        </b-form-checkbox>

        <b-form-textarea
            v-else-if="_type == 'textarea'"
            v-model="parent.instance[field]"
            :required = "_required"
            :readonly="_readonly"
            :state="state"/>

        <b-form-select
            v-else-if="_type == 'choice'"
            v-model="parent.instance[field]" 
            :required = "_required"
            :options = "_options"
            :size="size"/>
        
        <b-form-file 
            v-else-if="_type == 'file upload'"
            v-model="parent.instance[field]"
            :browse-text="browseText"
            :placeholder="placeholder"
            :required = "_required"
            :size="size"
            />

        <b-form-file 
            v-else-if="_type == 'image upload'"
            accept="image/*"
            v-model="parent.instance[field]"
            :browse-text="browseText"
            :placeholder="placeholder"
            :required = "_required"
            :size="size"
            />


        <div v-else>
            <pre>[Unknown field type: {{_type}}]</pre>
        </div>
    </b-form-group>

</template>

<script>
export default{
    data(){
        return {
            
        }
    },
    props:{
        browseText:{},
        placeholder:{},
        field:{
            type: String,
            default: null
        },
        type:{
            type: String,
        },
        label:{
            type: String,
            default: null
        },
        readonly:{
            type: Boolean,
            default: false
        },
        required:{
            type: Boolean,
            default: false
        },
        size:{
            type: String,
            required: false
        },
        options:{
            type: Array,
            required: false,
            default: null,
        }
    },
    computed:{
        parent(){
            return this.getParent('RestForm')
        },
        _options(){
            if(this.options == null){
                try{
                    return this.getFieldProperty('choices')
                    .map(o=>{
                        return {value: o.value, text: o.display_name}
                    })
                }catch(e){
                    return []
                }
            }else{
                return this.options
            }
        },
        _type_normalized(){
            switch(this._type){
                case 'text': return 'textarea';
                case 'string': return 'text';
                case 'integer': return 'number';
                default: return this._type
            }
        },
        _type(){
            if(this.getFieldProperty('type')){
                return this.getFieldProperty('type')
            }else{
                return 'string'
            }
        },
        state(){
            if(this.parent.form_errors[this.field] != undefined){
                return false
            }
        },
        _required(){
            return this.getFieldProperty('required')
        },
        _readonly(){
            return this.getFieldProperty('read_only')
        },
        _label(){
            return this.getFieldProperty('label')
        }, 
        invalid_feedback(){
            return Array(this.parent.form_errors[this.field]).toString()
        }
    },
    mounted(){

    },
    methods:{
        getFieldProperty(property){
            if(!this[property] && this.parent.render_fields[this.field]){
                return this.parent.render_fields[this.field][property]
            }else{
                return this[property]
            }
        },
        getParent(name) {
            let p = this.$parent;
            while(typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false
        },
    }
}
</script>


<style lang="scss" scoped>
.req_mark{
    color: red
}
</style>